import { createTypedValidator } from '@takeshape/json-schema';
const runModes = ['ALLOW_BACKGROUND', 'BACKGROUND', 'IMMEDIATE'];
export const shapeName = 'TSAgentRunMode';
export const schema = {
    enum: [...runModes]
    // description:
    //   'The mode in which the agent should run. "ALLOW_BACKGROUND" allows runs that would timeout to run longer in the background, "BACKGROUND" only runs in the background and results will need to be polled for. "IMMEDIATE" runs immediately and will timeout if it takes too long.'
};
export const validate = createTypedValidator(schema);
